import React, {Component} from 'react'
import { push } from 'react-router-redux';
import {connect} from 'react-redux'
import { Button } from "semantic-ui-react";
import {gunaldiStyles} from "../../SharedComponents/GunaldiDesignStyles";
import API_Backend_Root from "../../Constants/API_Backend_Root";
import AceEditor from "react-ace";
import 'brace/mode/python';
import RequestURLBox from "../../SharedComponents/RequestURLBox";

class APICustomUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customApi: null,
            loading: false,
            error: null,
            currentStep: 1,  // 1 = Code, 2 = Schedule
            code: '',
            saving: false,
            schedule: {
                enabled: false,
                frequency: 'daily', // 'daily', 'weekly', 'monthly', 'custom'
                time: '09:00', // HH:MM format
                days: [], // for weekly/monthly
                customCron: '', // for custom cron expressions
                timezone: 'UTC'
            },
            accessKey: null,
            secretKey: null
        };
        this.handleBackToCustomAPIs = this.handleBackToCustomAPIs.bind(this);
        this.handleDeleteCustomAPI = this.handleDeleteCustomAPI.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleCodeChange = this.handleCodeChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        this.fetchAccountKeys();
    }

    fetchAccountKeys = async () => {
        try {
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                this.setState({ 
                    error: "User authentication not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "fetch-account-keys/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userEmail,
                    token: userToken,
                    env: localStorage.getItem("env")
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    accessKey: data.access_key,
                    secretKey: data.secret_key
                }, () => {
                    // After setting the keys, fetch custom API details
                    this.fetchCustomAPIDetails();
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch account keys",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching account keys:', error);
            this.setState({ 
                error: "Network error while fetching account keys",
                loading: false 
            });
        }
    }

    fetchCustomAPIDetails = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + `custom/details/${this.props.match.params.customapi_hash}/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch custom API details: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            // Load schedule from the schedule column, with fallback to default
            const savedSchedule = data.custom_api.schedule || {};
            const defaultSchedule = {
                enabled: false,
                frequency: 'daily',
                time: '09:00',
                days: [],
                customCron: '',
                timezone: 'UTC'
            };
            
            this.setState({ 
                customApi: data.custom_api,
                code: (data.custom_api.data && data.custom_api.data.code) || this.getDefaultCode(),
                schedule: {
                    ...defaultSchedule,
                    ...savedSchedule  // Override with saved schedule data
                },
                loading: false 
            });
            
        } catch (error) {
            console.error('Error fetching custom API details:', error);
            this.setState({ 
                error: error.message || "Failed to fetch custom API details",
                loading: false 
            });
        }
    }

    getDefaultCode = () => {
        return "## ENTER YOUR CODE HERE AND MAKE SURE IT RETURNS A STATUS CODE AND BODY LIKE FOLLOWS\ndef api(request_body, headers):\n\treturn 200, {'data': 'my data'}"
    }

    handleBackToCustomAPIs = () => {
        this.props.navigateTo('/utilities');
    }

    handleDeleteCustomAPI = async () => {
        // Show confirmation dialog
        const confirmed = window.confirm(
            'Are you sure you want to delete this custom API? This action will permanently delete:\n\n' +
            '• The custom API and all its settings\n' +
            '• All associated data and configurations\n\n' +
            'This action cannot be undone.'
        );
        
        if (!confirmed) {
            return;
        }
        
        try {
            this.setState({ loading: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }
            
            const response = await fetch(API_Backend_Root + `custom/delete/${this.props.match.params.customapi_hash}/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({})
            });
            
            if (!response.ok) {
                throw new Error(`Failed to delete custom API: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            // Show success message
            alert('Custom API deleted successfully!');
            
            // Navigate back to custom APIs list
            this.props.navigateTo('/utilities');
            
        } catch (error) {
            console.error('Error deleting custom API:', error);
            this.setState({ 
                error: error.message || "Failed to delete custom API",
                loading: false 
            });
        }
    }

    handleStepClick = (stepNumber) => {
        this.setState({ currentStep: stepNumber });
    }

    handleCodeChange = (updatedCode) => {
        this.setState({ code: updatedCode });
    }

    handleScheduleChange = (field, value) => {
        this.setState(prevState => ({
            schedule: {
                ...prevState.schedule,
                [field]: value
            }
        }));
    }

    handleDayToggle = (day) => {
        this.setState(prevState => ({
            schedule: {
                ...prevState.schedule,
                days: prevState.schedule.days.includes(day) 
                    ? prevState.schedule.days.filter(d => d !== day)
                    : [...prevState.schedule.days, day]
            }
        }));
    }
    
    generateSchedulePreview = () => {
        const { schedule } = this.state;
        
        if (!schedule.enabled) {
            return "Schedule is disabled";
        }
        
        const time = schedule.time;
        
        switch (schedule.frequency) {
            case 'daily':
                return `Runs daily at ${time} ${schedule.timezone}`;
            case 'weekly':
                const dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
                const selectedDays = schedule.days.map(dayIndex => dayNames[dayIndex]).join(', ');
                return `Runs weekly on ${selectedDays} at ${time} ${schedule.timezone}`;
            case 'monthly':
                return `Runs monthly on day ${schedule.days[0] || 1} at ${time} ${schedule.timezone}`;
            case 'custom':
                return `Custom cron: ${schedule.customCron || 'Not specified'} (${schedule.timezone})`;
            default:
                return "Invalid schedule configuration";
        }
    }

    handleSave = async () => {
        try {
            this.setState({ saving: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    saving: false 
                });
                return;
            }

            // Update the data object with the new code
            const updatedData = {
                ...this.state.customApi.data,
                code: this.state.code
            };

            // Prepare request body - only include schedule if it's enabled
            const requestBody = {
                data: updatedData,
                schedule: this.state.schedule
            };

            // Only include schedule if it's enabled
            if (this.state.schedule.enabled) {
                requestBody.schedule = this.state.schedule;
            }

            const response = await fetch(API_Backend_Root + `custom/update/${this.props.match.params.customapi_hash}/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`Failed to save: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            this.setState({ 
                customApi: data.custom_api,
                saving: false,
                saveSuccess: true,
                saveSuccessType: this.state.currentStep === 1 ? 'code' : 'schedule'
            });
            
            // Clear success message after 3 seconds
            setTimeout(() => {
                this.setState({ saveSuccess: false, saveSuccessType: null });
            }, 3000);
            
        } catch (error) {
            console.error('Error saving custom API:', error);
            this.setState({ 
                error: error.message || "Failed to save custom API",
                saving: false 
            });
        }
    }

    renderStepContent = () => {
        switch(this.state.currentStep) {
            case 1: // Code
                return (
                    <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                        {/* Success message for code section */}
                        {this.state.saveSuccess && this.state.saveSuccessType === 'code' && (
                            <div style={{ 
                                backgroundColor: '#e8f5e8', 
                                padding: '12px', 
                                borderRadius: '6px',
                                border: '1px solid #c3e6c3',
                                marginBottom: '20px'
                            }}>
                                <p style={{ margin: 0, fontSize: '14px', color: '#2e7d32' }}>
                                    <strong>Success:</strong> Code has been successfully saved
                                </p>
                            </div>
                        )}
                        <div style={{ marginBottom: '20px' }}>
                            <RequestURLBox url={API_Backend_Root + "custom/" + this.props.match.params.customapi_hash + "/"} 
                            style={{borderColor: '#333'}}/>
                        </div>
                        <div style={{ marginBottom: '20px', borderRadius: '6px', border: '1px solid #9696A0', padding: '10px', backgroundColor: '#2F3129' }}>
                        <AceEditor
                            mode="python"
                            theme="monokai"
                            value={this.state.code}
                            onChange={this.handleCodeChange}
                            name="custom_api_code_editor"
                            editorProps={{$blockScrolling: true}}
                            height={500}
                            width="100%"
                            setOptions={{
                                useSoftTabs: true,
                                tabSize: 4,
                                insertSpaces: true
                            }}
                        />
                        </div>
                        <div style={{ 
                            backgroundColor: '#e3f2fd', 
                            padding: '12px', 
                            borderRadius: '6px',
                            border: '1px solid #bbdefb'
                        }}>
                            <p style={{ margin: 0, fontSize: '14px', color: '#1976d2' }}>
                                <strong>Note:</strong> Write your Python code here. The code will be executed when the API is called. Make sure your function returns a status code and response body.
                            </p>
                        </div>
                    </div>
                );
                case 2: // Schedule
                    return (
                        <div style={{ padding: '20px' }}>
                            {/* Success message for schedule section */}
                            {this.state.saveSuccess && this.state.saveSuccessType === 'schedule' && (
                                <div style={{ 
                                    backgroundColor: '#e8f5e8', 
                                    padding: '12px', 
                                    borderRadius: '6px',
                                    border: '1px solid #c3e6c3',
                                    marginBottom: '20px'
                                }}>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#2e7d32' }}>
                                        <strong>Success:</strong> Schedule has been saved and applied. The API will activate at the specified time.
                                    </p>
                                </div>
                            )}
                            <h3 style={{ marginBottom: '20px', color: '#333' }}>Schedule Configuration</h3>
                            
                            {/* Enable/Disable Schedule */}
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        checked={this.state.schedule.enabled}
                                        onChange={(e) => this.handleScheduleChange('enabled', e.target.checked)}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <span style={{ fontSize: '16px', fontWeight: '500' }}>Enable Scheduled Execution</span>
                                </label>
                            </div>
                
                            {this.state.schedule.enabled && (
                                <div style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    padding: '20px', 
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef'
                                }}>
                                    {/* Frequency Selection */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500' }}>
                                            Frequency:
                                        </label>
                                        <select
                                            value={this.state.schedule.frequency}
                                            onChange={(e) => this.handleScheduleChange('frequency', e.target.value)}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '4px',
                                                border: '1px solid #ddd',
                                                fontSize: '14px',
                                                width: '200px'
                                            }}
                                        >
                                            <option value="daily">Daily</option>
                                            <option value="weekly">Weekly</option>
                                            <option value="monthly">Monthly</option>
                                            <option value="custom">Custom Cron</option>
                                        </select>
                                    </div>
                
                                    {/* Time Selection */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500' }}>
                                            Time:
                                        </label>
                                        <input
                                            type="time"
                                            value={this.state.schedule.time}
                                            onChange={(e) => this.handleScheduleChange('time', e.target.value)}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '4px',
                                                border: '1px solid #ddd',
                                                fontSize: '14px'
                                            }}
                                        />
                                    </div>
                
                                    {/* Days Selection for Weekly */}
                                    {this.state.schedule.frequency === 'weekly' && (
                                        <div style={{ marginBottom: '20px' }}>
                                            <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500' }}>
                                                Days of Week:
                                            </label>
                                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day, index) => (
                                                    <label key={day} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.schedule.days.includes(index)}
                                                            onChange={() => this.handleDayToggle(index)}
                                                            style={{ marginRight: '5px' }}
                                                        />
                                                        <span style={{ fontSize: '14px' }}>{day}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                
                                    {/* Days Selection for Monthly */}
                                    {this.state.schedule.frequency === 'monthly' && (
                                        <div style={{ marginBottom: '20px' }}>
                                            <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500' }}>
                                                Day of Month:
                                            </label>
                                            <select
                                                value={this.state.schedule.days[0] || 1}
                                                onChange={(e) => this.handleScheduleChange('days', [parseInt(e.target.value)])}
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #ddd',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {Array.from({length: 31}, (_, i) => i + 1).map(day => (
                                                    <option key={day} value={day}>{day}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                
                                    {/* Custom Cron Expression */}
                                    {this.state.schedule.frequency === 'custom' && (
                                        <div style={{ marginBottom: '20px' }}>
                                            <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500' }}>
                                                Custom Cron Expression:
                                            </label>
                                            <input
                                                type="text"
                                                value={this.state.schedule.customCron}
                                                onChange={(e) => this.handleScheduleChange('customCron', e.target.value)}
                                                placeholder="0 9 * * * (minute hour day month weekday)"
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #ddd',
                                                    fontSize: '14px',
                                                    width: '300px'
                                                }}
                                            />
                                            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                                Format: minute hour day month weekday (e.g., "0 9 * * *" for daily at 9 AM)
                                            </div>
                                        </div>
                                    )}
                
                                    {/* Timezone Selection */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500' }}>
                                            Timezone:
                                        </label>
                                        <select
                                            value={this.state.schedule.timezone}
                                            onChange={(e) => this.handleScheduleChange('timezone', e.target.value)}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '4px',
                                                border: '1px solid #ddd',
                                                fontSize: '14px',
                                                width: '200px'
                                            }}
                                        >
                                            <option value="UTC">UTC</option>
                                            <option value="America/New_York">Eastern Time</option>
                                            <option value="America/Chicago">Central Time</option>
                                            <option value="America/Denver">Mountain Time</option>
                                            <option value="America/Los_Angeles">Pacific Time</option>
                                            <option value="Europe/London">London</option>
                                            <option value="Europe/Paris">Paris</option>
                                            <option value="Asia/Tokyo">Tokyo</option>
                                        </select>
                                    </div>
                
                                    {/* Schedule Preview */}
                                    <div style={{ 
                                        backgroundColor: '#e8f5e8', 
                                        padding: '12px', 
                                        borderRadius: '4px',
                                        border: '1px solid #c3e6c3'
                                    }}>
                                        <strong>Schedule Preview:</strong>
                                        <div style={{ marginTop: '5px', fontSize: '14px' }}>
                                            {this.generateSchedulePreview()}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
            default:
                return <div>No content available for this step.</div>;
        }
    }

    render() {
        if (this.state.loading && !this.state.customApi) {
            return (
                <div style={{ padding: "24px 48px" }}>
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                        Loading custom API details...
                    </div>
                </div>
            );
        }

        if (this.state.error && !this.state.customApi) {
            return (
                <div style={{ padding: "24px 48px" }}>
                    <div style={{ 
                        backgroundColor: '#ffebee', 
                        color: '#c62828', 
                        padding: '12px', 
                        borderRadius: '4px', 
                        marginBottom: '20px' 
                    }}>
                        Error: {this.state.error}
                    </div>
                    <button onClick={this.handleBackToCustomAPIs}>
                        ← Back to Custom APIs
                    </button>
                </div>
            );
        }

        if (!this.state.customApi) {
            return (
                <div style={{ padding: "24px 48px" }}>
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                        Custom API not found.
                    </div>
                    <button onClick={this.handleBackToCustomAPIs}>
                        ← Back to Custom APIs
                    </button>
                </div>
            );
        }

        return (
            <div style={{ padding: "24px 48px" }}>
                <div style={{ color: '#333', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'Lato', marginBottom: '20px' }}>
                    <button 
                        onClick={this.handleBackToCustomAPIs}
                        style={{
                            backgroundColor: '#fff', 
                            color: '#333', 
                            borderRadius: '5px', 
                            border: '1px solid rgb(150, 150, 160)', 
                            cursor: 'pointer', 
                            outline: 'none',
                            padding: '8px 20px',
                        }}
                    >
                        <span style={{fontSize: '16px', fontWeight: '700'}}>←</span> 
                        <span style={{fontSize: '14px', fontWeight: '500', marginLeft: '6px'}}>Custom APIs</span> 
                    </button>
                    <h2 style={{ margin: 0, textAlign: 'center', flex: 1, padding: '0 20px' }}>{this.state.customApi.api_name || 'Untitled API'}</h2>
                    <button
                        onClick={this.handleDeleteCustomAPI}
                        disabled={this.state.loading}
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '12px 20px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: this.state.loading ? 'not-allowed' : 'pointer',
                            outline: 'none',
                            transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            if (!this.state.loading) {
                                e.target.style.backgroundColor = '#c82333';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!this.state.loading) {
                                e.target.style.backgroundColor = '#dc3545';
                            }
                        }}
                    >
                        {this.state.loading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>

                {/* Horizontal line separator */}
                <div style={{ borderBottom: '1px solid #e0e0e0', marginBottom: '20px' }}></div>
                
                {/* Three-column layout */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(150px, 180px) 1fr minmax(150px, 180px)',
                    gap: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '20px',
                    minHeight: '500px',
                    border: '1px solid #9696A0'
                }}>
                    {/* Left column - Menu buttons */}
                    <div style={{ backgroundColor: 'white', borderRadius: '6px', padding: '4px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <button
                                onClick={() => this.handleStepClick(1)}
                                style={{
                                    border: this.state.currentStep === 1 ? '1px solid #5499F8' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 1 ? '#5499F8' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '13px',
                                    fontWeight: this.state.currentStep === 1 ? '600' : '400',
                                    color: this.state.currentStep === 1 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '8px 12px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Code</span>
                            </button>
                            <button
                                onClick={() => this.handleStepClick(2)}
                                style={{
                                    border: this.state.currentStep === 2 ? '1px solid #5499F8' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 2 ? '#5499F8' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '13px',
                                    fontWeight: this.state.currentStep === 2 ? '600' : '400',
                                    color: this.state.currentStep === 2 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '8px 12px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Schedule</span>
                            </button>
                        </div>
                    </div>

                    {/* Middle column - Content display */}
                    <div style={{ 
                        backgroundColor: 'white', 
                        borderRadius: '0px', 
                        padding: '20px', 
                        borderLeft: '1px solid #9696A0', 
                        borderRight: '1px solid #9696A0',
                        minWidth: 0,
                        overflow: 'hidden'
                    }}>
                        {this.renderStepContent()}
                    </div>

                    {/* Right column - Action buttons */}
                    <div style={{ backgroundColor: 'white', borderRadius: '0px'}}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <Button 
                                content="Save"
                                icon="save"
                                loading={this.state.saving}
                                onClick={this.handleSave}
                                style={{
                                    border:  '1px solid #5499F8',
                                    borderRadius: '6px',
                                    backgroundColor: '#5499F8',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#FFF',
                                    outline: 'none',
                                    padding: '14px 16px',
                                    whiteSpace: 'nowrap'
                                }}
                            />
        
                            {/* Rules section - only show when Code step is selected */}
                            {this.state.currentStep === 1 && (
                                <div style={{marginTop: '34px'}}>
                                    <h4 style={{ 
                                        margin: '0 0 12px 0', 
                                        fontSize: '13px', 
                                        fontWeight: '600',
                                        color: '#333'
                                    }}>
                                        Rules for creating a custom API
                                    </h4>
                                    <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.4' }}>
                                        <div style={{ marginBottom: '6px' }}>1. APIs can be called as a GET or POST</div>
                                        <div style={{ marginBottom: '6px' }}>2. DO NOT CHANGE the specified function name and parameters</div>
                                        <div style={{ marginBottom: '6px' }}>3. You can use the headers and request_body parameters to access your headers and request_body. Note, headers will be capitalized automatically</div>
                                        <div style={{ marginBottom: '6px' }}>4. You must return a tuple of status_code and response body from your code as shown</div>
                                        <div style={{ marginBottom: '0' }}>5. The response body must be returned even if it is None</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    // Add any state props you need
})

const mapActionsToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapActionsToProps)(APICustomUpdate)